import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers, applyMiddleware } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import userReducer from './reducers/userReducer';
import dataReducer from './reducers/dataReducer';
import { ProSidebarProvider } from 'react-pro-sidebar';


const container = document.getElementById('root');
const root = createRoot(container);

const rootReducer = combineReducers({
  userReducer: userReducer,
  dataReducer: dataReducer
})

const store = configureStore({ reducer: rootReducer }, composeWithDevTools(applyMiddleware(thunk)))

root.render(

  <BrowserRouter>
    <Provider store={store}>
      <ProSidebarProvider>
        <App />
      </ProSidebarProvider>
    </Provider>
  </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

